import { EventAggregator } from 'aurelia-event-aggregator';
import {
	autoinject,
	bindable,
	BindingEngine,
	bindingMode,
	customElement,
} from 'aurelia-framework';

import { Field } from '~/components/field/common/field';
import { Form } from '~/components/form/form';

@autoinject
@customElement('a-checkbox')
export class Checkbox extends Field {
	/**
	 * Is it checked?
	 */
	@bindable({
		defaultBindingMode: bindingMode.twoWay,
	})
	protected checked: boolean = true;

	@bindable({
		defaultBindingMode: bindingMode.twoWay,
	})
	private model: any;

	constructor(
		public element: Element,
		protected parentForm: Form,
		readonly eventAggregator: EventAggregator,
		protected bindingEngine: BindingEngine,
	) {
		super(Field.TYPE.CHECKBOX, element, parentForm, eventAggregator);
	}

	public attached() {
		super.attached();
	}
}
